<template>
    <v-container>
        <v-row>
            {{language=='Ελληνικά'? 'ΦΙΛΤΡΑ' : 'FILTERS'}}
            <v-col v-if="!old" cols="12">
                <v-select
                        :label="language=='Ελληνικά'? 'Τύπος' : 'Type'"
                        clearable
                        color="red"
                        :items="types"
                        v-model="filter.type"
                ></v-select>
            </v-col>

            <v-col cols="12">
                <v-select
                        :label="language=='Ελληνικά'? 'Περιοχή' : 'Area'"
                        clearable
                        color="red"
                        :items="addresses"
                        v-model="filter.address"
                ></v-select>
            </v-col>

            <v-col v-if="!old" cols="12">
                <v-select
                        :label="language=='Ελληνικά'? 'Έτος κατασκευής' : 'Construction year'"
                        clearable
                        color="red"
                        :items="years"
                        v-model="filter.year"
                ></v-select>
            </v-col>

            <v-col v-if="!old" cols="12">
                <v-combobox
                        :label="language=='Ελληνικά'? 'Όροφος' : 'Floor'"
                        color="red"
                        :items="floors"
                        multiple
                        v-model="filter.floor"
                ></v-combobox>
            </v-col>

            <v-col v-if="!old" cols="12">
                {{language=='Ελληνικά'? 'Μέγεθος τ.μ. από - έως:' : 'Size s.m. from - to:'}}
                <v-range-slider
                    v-model="filter.range"
                    :max="max"
                    :min="min"
                    hide-details
                    class="align-center"
                    color="red"
                    thumb-color="#898989"
                    track-color="#adacac"
                >
                    <template v-slot:prepend>
                    <v-text-field
                        :value="filter.range[0]"
                        class="mt-0 pt-0"
                        hide-details
                        single-line
                        type="number"
                        style="width: 60px"
                        @change="$set(filter.range, 0, $event)"
                    ></v-text-field>
                    </template>
                    <template v-slot:append>
                    <v-text-field
                        :value="filter.range[1]"
                        class="mt-0 pt-0"
                        hide-details
                        single-line
                        type="number"
                        style="width: 60px"
                        @change="$set(filter.range, 1, $event)"
                    ></v-text-field>
                    </template>
                </v-range-slider>
            </v-col>
            <v-col cols="6" align="end">
                <v-btn :loading="loading" color="error" class="white--text" @click="$emit('fetchProjects')">{{language=='Ελληνικά'? 'Εφαρμογη' : 'Submit'}}</v-btn>
            </v-col>
            <v-col cols="6" align="start">
                <v-btn dark color="#898989" @click="resetFilters()">{{language=='Ελληνικά'? 'Καθαρισμος' : 'Clear'}}</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import restApi from "@/rest-api";

    export default {
        props: {
            language: {
                type: String,
                value: null
            },
            available: {
                type: Boolean,
                value: false
            },
            loading: {
                type: Boolean,
                value: false
            }
        },
        data() {
            return {
                filter:{range:[0,500]},
                old: false,
                min: 0,
                max: 500,
                floors: [],
                years: [],
                types: [],
                addresses: [],
                floorMap: {
                    'Α':1,
                    'A':1,
                    'Β':2,
                    'B':2,
                    'Γ':3,
                    'C':3,
                    'Δ':4,
                    'D':4,
                    'Ε':5,
                    'E':5,
                    'ΣΤ':6,
                    'Ζ':7,
                    'Z':7,
                    'Η':8,
                    'H':8,
                    'Θ':9,
                    'Ι':10,
                    'I':10,
                    'Κ':11,
                    'K':11,
                    'Λ':12,
                    'ΙΣ':0
                },
            }
        },
        watch: {
            filter() {
                this.$store.dispatch("setFilters", this.filter)
            },
            language() {
                this.resetFilters();
                if(this.$route.path=='/Projects/All/Old'){
                this.fetchAddresses()
                delete this.filter.range
                this.old = true
                } else {
                    this.fetchTypes();
                    this.fetchYears();
                    this.fetchTypes();
                    this.fetchFloors();
                    this.fetchAddresses();
                }
            },
            '$route.name': {
                handler(value) {
                    if(value === 'Available Projects') {
                        this.old = false
                        this.fetchTypes();
                        this.fetchYears();
                        this.fetchTypes();
                        this.fetchFloors();
                        this.fetchAddresses();
                    }
                }
           }
        },
        created() {
            if(this.$route.path=='/Projects/All/Old'){
                this.fetchAddresses()
                delete this.filter.range
                this.old = true
            } else {
                this.fetchTypes();
                this.fetchYears();
                this.fetchTypes();
                this.fetchFloors();
                this.fetchAddresses();
            }
        },
        methods: {
            resetFilters() {
                if(this.$route.path=='/Projects/All/Old'){
                    this.filter = {}
                    this.type = ''
                    this.address = ''
                } else {
                    this.filter = {range:[0,500]}
                    this.type = ''
                    this.address = ''
                }
            },
            fetchYears() {
                var search = `/project/years`;
                restApi
                .get(search)
                .then(response => {
                    this.years = response.map(year => year.year);
                   })
                .catch((error) => {
                    console.log(error);
                });
            },
            fetchTypes() {
                var search = `/project/types`;
                if(this.language!='Ελληνικά'){
                    search = `/project/types?lang=En`;
                } else {
                    search = `/project/types`;
                }
                restApi
                .get(search)
                .then(response => {
                    if(this.language!='Ελληνικά'){
                        this.types = response.map(type => type.typeEn);
                    } else {
                        this.types = response.map(type => type.type);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
            },
            fetchAddresses() {
                var search = ''
                if(!this.old && this.language!='Ελληνικά'){
                    search = `/project/addresses?lang=En`;
                } else if(!this.old && this.language == 'Ελληνικά') {
                    search = `/project/addresses`;
                } else if (this.old && this.language =='Ελληνικά') {
                    search = `/project/addresses?type=old`;
                } else {
                    search = `/project/addresses?type=old&&lang=En`;
                }
                restApi
                .get(search)
                .then(response => {
                    if(this.language!='Ελληνικά'){
                        this.addresses = response.map(address => address.addressEn.split(',')[1].trim());
                    } else {
                        this.addresses = response.map(address => address.address.split(',')[1].trim());
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
            },
            fetchFloors() {
                var search = `/project/floors`;
                restApi
                .get(search)
                .then(response => {
                    this.floors = response.map(floor => parseInt(floor.floor) ? floor.floor : floor.floor=this.getFloor(floor));
                    this.floors.sort(function(a, b){return a-b})
                    this.floors = new Set(this.floors)
                    this.floors = [...this.floors]
                   })
                .catch((error) => {
                    console.log(error);
                });
            },
            getFloor(floor) {
                let tfloor = floor.title.split(/(\d+)/)[0]  
                if(!tfloor) {
                    floor = floor.title.split(/(\d+)/)[1]
                    return parseInt(floor)
                } 
                if(this.floorMap[tfloor] != undefined)
                { 
                    return this.floorMap[tfloor]
                } else {
                    return 'NA'
                }
            }
        }
    }
</script>
<style lang="scss" scoped>

</style>
